import { render, staticRenderFns } from "./ShippingAddressListModal.vue?vue&type=template&id=4485bee1&scoped=true&"
import script from "./ShippingAddressListModal.vue?vue&type=script&lang=js&"
export * from "./ShippingAddressListModal.vue?vue&type=script&lang=js&"
import style0 from "./ShippingAddressListModal.vue?vue&type=style&index=0&id=4485bee1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4485bee1",
  null
  
)

export default component.exports